export default __webpack_public_path__ + "static/media/yelp.8eafa880.png";